import { Component, h, Host, State, Element, Prop } from '@stencil/core';

@Component({
  tag: 'pn-mainnav-list',
  styleUrl: 'pn-mainnav-list.scss',
  shadow: false,
})
export class PnMainnavList {
  @Element() hostElement: HTMLElement;

  @Prop() heading: string = '';
  @State() linkCount: number = 0;

  componentWillLoad() {
    this.linkCount = this.hostElement.querySelectorAll(':scope > pn-mainnav-link').length;
  }

  render() {
    return (
      <Host class="mainnav-list" role="list" data-navlist-itemcount={this.linkCount + ''} data-navlist-showcolumns={(this.linkCount >= 8) + ''}>
        {this.heading ? <div class="mainnav-list-heading">{this.heading}</div> : null}
        <slot></slot>
      </Host>
    );
  }
}
